import React, {MouseEventHandler} from 'react'
import {Box, Button} from '@miro-site/core'
import styled, {css} from 'styled-components'
import animation from '@miro-site/design-tokens/src/foundation/animation'
import {HeaderAppearance} from '../../types/Header'
import {isDarkTheme} from '../utils'

interface BurgerMenuProps {
  onClick?: MouseEventHandler<HTMLButtonElement>
  appearance?: HeaderAppearance
  $isMobileMenuOpened?: boolean
}

const BurgerButton = styled(Button)<BurgerMenuProps>`
  ${props =>
    props.theme.normalizeStyles({
      width: props.theme.header.burger.size,
      height: props.theme.header.burger.size,
      right: props.theme.header.container.horizontalPadding,
      ':focus': {
        ...props.theme.focus.outlines.withOffset,
      },
    })}

  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  .focus-trap {
    display: block;
    height: 100%;
  }

  ${({$isMobileMenuOpened}) =>
    $isMobileMenuOpened &&
    css`
      &:hover {
        ${BurgerLine} {
          ${props =>
            props.theme.normalizeStyles({
              background: props.theme.header.burger.hoverColor,
            })}
        }
      }

      ${BurgerLine} {
        ${props =>
          props.theme.normalizeStyles({
            background: props.theme.header.burger.activeColor,
          })}

        &:nth-of-type(1) {
          ${props =>
            props.theme.normalizeStyles({
              transform: `rotate(45deg) translateX(5px) translateY(5px)`,
            })}
        }

        &:nth-of-type(2) {
          opacity: 0;
        }

        &:nth-of-type(3) {
          ${props =>
            props.theme.normalizeStyles({
              transform: `rotate(-45deg) translateX(5px) translateY(-5px)`,
            })}
        }
      }
    `}
`

const BurgerButtonLines = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
})``

const BurgerLine = styled(Box).attrs<{$appearance: HeaderAppearance}>({})<{
  $appearance: HeaderAppearance
}>`
  ${({theme, $appearance}) =>
    theme.normalizeStyles({
      background: isDarkTheme($appearance)
        ? theme.header.burger.activeColor
        : theme.header.burger.color,
      height: theme.header.burger.line.height,
      borderRadius: theme.header.burger.line.radius,
    })}

  width: 100%;

  transition: ${animation.transitionDuration};
  transition-property: transform, opacity, background, width;

  &:nth-of-type(1) {
    margin-bottom: 5px;
  }

  &:nth-of-type(2) {
    margin-bottom: 5px;
  }
`

const BurgerMenu = (props: BurgerMenuProps): React.ReactElement => {
  return (
    <BurgerButton {...props}>
      <BurgerButtonLines>
        <BurgerLine $appearance={props.appearance} />
        <BurgerLine $appearance={props.appearance} />
        <BurgerLine $appearance={props.appearance} />
      </BurgerButtonLines>
    </BurgerButton>
  )
}

export default BurgerMenu
